/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Prices_To_CompleteInputs */

const en_queue_prices_to_complete = /** @type {(inputs: Queue_Prices_To_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices to complete`)
};

/**
* | output |
* | --- |
* | "Prices to complete" |
*
* @param {Queue_Prices_To_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_prices_to_complete = /** @type {((inputs?: Queue_Prices_To_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Prices_To_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_prices_to_complete(inputs)
});